export const BillingCypressAttribute = {
  buttons: {
    USER_MENU_ADD_PLAN: 'BillingCypressAttribute:USER_MENU_ADD_PLAN',
    SELECT_PLAN: 'BillingCypressAttribute:SELECT_PLAN',
    CHANGE_PLAN: 'BillingCypressAttribute:CHANGE_PLAN',
    DOWNLOAD_INVOICE: 'BillingCypressAttribute:DOWNLOAD_INVOICE',
    ADD_PAYMENT_METHOD: 'BillingCypressAttribute:ADD_PAYMENT_METHOD',
    ADD_PRODUCT: 'BillingCypressAttribute:buttons:ADD_PRODUCT',
    REMOVE_PRODUCT: 'BillingCypressAttribute:buttons:REMOVE_PRODUCT',
    MANAGE_PLAN: 'BillingCypressAttribute:buttons:MANAGE_PLAN',
    CANCEL_PLAN: 'BillingCypressAttribute:buttons:CANCEL_PLAN',
    UNCANCEL_PLAN: 'BillingCypressAttribute:buttons:UNCANCEL_PLAN'
  },
  inputs: {
    FEEDBACK: 'BillingCypressAttribute:inputs:FEEDBACK',
    FEEDBACK_OTHER: 'BillingCypressAttribute:inputs:FEEDBACK_OTHER'
  },
  views: {
    SELECT_PLAN_MODAL: 'BillingCypressAttribute:SELECT_PLAN_MODAL',
    PLAN_WIDGET: 'BillingCypressAttribute:PLAN_WIDGET',
    INVOICE_WIDGET: 'BillingCypressAttribute:INVOICE_WIDGET',
    ADDONS_WIDGET: 'BillingCypressAttribute:ADDONS_WIDGET',
    PAYMENT_METHOD_WIDGET: 'BillingCypressAttribute:PAYMENT_METHOD_WIDGET',
    INCLUSIONS: 'BillingCypressAttribute:views:INCLUSIONS',
    EXCLUSIONS: 'BillingCypressAttribute:views:EXCLUSIONS',
    INCLUSIONS_EXCLUSIONS: 'BillingCypressAttribute:views:INCLUSIONS_EXCLUSIONS',
    CURRENT_PLAN_LINE_ITEM: 'BillingCypressAttribute:views:CURRENT_PLAN_LINE_ITEM',
    MANAGED_BY_PARTNER_BANNER: 'BillingCypressAttribute:views:MANAGED_BY_PARTNER_BANNER',
    PROTECTION_MANDATE_MODAL: 'BillingCypressAttribute:views:PROTECTION_MANDATE_MODAL',
    CANCELLATION_MODAL: 'BillingCypressAttribute:views:CANCELLATION_MODAL',
    FINANCIAL_ADVISOR_CONSENT_FORM_CHECHBOX:
      'BillingCypressAttribute:views:FINANCIAL_ADVISOR_CONSENT_FORM_CHECHBOX',
    PROFESSIONAL_EXECUTOR_UPSELL_VIEW:
      'BillingCypressAttribute:views:PROFESSIONAL_EXECUTOR_UPSELL_VIEW',
    BILLING_PORTAL_REDIRECT: 'BillingCypressAttribute:views:BILLING_PORTAL_REDIRECT'
  },
  checkout: {
    buttons: {
      PROCEED_TO_CHECKOUT: 'button[data-cb-id="cart_submit"]',
      ADDRESS_NEXT: 'button[data-cb-id="address_submit"]',
      CREDIT_CARD_NEXT: 'button[data-cb-id="card_payment_submit"]',
      ENABLE_PLAN: 'button[data-cb-id="review_submit"]',
      NEXT_PAYMENT_METHOD: 'BillingCypressAttribute:checkout:buttons:NEXT_PAYMENT_METHOD',
      STRIPE_PAYMENT_SELECTOR: 'BillingCypressAttribute:checkout:buttons:STRIPE_PAYMENT_SELECTOR',
      UPLIFT_PAYMENT_SELECTOR: 'BillingCypressAttribute:checkout:buttons:UPLIFT_PAYMENT_SELECTOR',
      PAY_NOW: 'BillingCypressAttribute:checkout:buttons:PAY_NOW',
      UPLIFT_PAY_NOW: 'BillingCypressAttribute:checkout:buttons:UPLIFT_PAY_NOW'
    },
    inputs: {
      FIRST_NAME: 'input#first_name',
      LAST_NAME: 'input#last_name',
      ADDRESS_LINE: 'input#line1',
      CREDIT_CARD_NUMBER: 'input#number',
      AGREED_TO_TERMS: 'BillingCypressAttribute:checkout:inputs:AGREED_TO_TERMS',
      CHECKOUT_CONSENT: 'BillingCypressAttribute:checkout:inputs:CHECKOUT_CONSENT',
      CHECKOUT_PRIVACY_CONSENT: 'BillingCypressAttribute:checkout:inputs:CHECKOUT_PRIVACY_CONSENT',
      CHECKOUT_CONNECTED_ACCOUNT_CONSENT:
        'BillingCypressAttribute:checkout:inputs:CHECKOUT_CONNECTED_ACCOUNT_CONSENT',
      CHECKOUT_PARTNER_SERVICE_AGREEMENT_CONSENT:
        'BillingCypressAttribute:checkout:inputs:CHECKOUT_PARTNER_SERVICE_AGREEMENT_CONSENT'
    },
    links: {
      FEE_SCHEDULE: 'BillingCypressAttribute:checkout:links:FEE_SCHEDULE',
      PURCHASE_TERMS: 'BillingCypressAttribute:checkout:links:PURCHASE_TERMS',
      PRIVACY_POLICY: 'BillingCypressAttribute:checkout:links:PRIVACY_POLICY',
      CAIN_LAMARRE_PRIVACY_POLICY:
        'BillingCypressAttribute:checkout:links:CAIN_LAMARRE_PRIVACY_POLICY',
      TERMS_OF_USE: 'BillingCypressAttribute:checkout:links:TERMS_OF_USE',
      PARTNER_SERVICE_AGREEMENT: 'BillingCypressAttribute:checkout:links:PARTNER_SERVICE_AGREEMENT',
      UPGRADE_PAY_LINK: 'BillingCypressAttribute:checkout:links:UPGRADE_PAY_LINK'
    },
    views: {
      ADDRESS_LINE_AUTOCOMPLETION_LIST: 'div.pac-container.pac-logo',
      CHECKOUT_SUCCESS_FIRST_INSTRUCTION_TITLE:
        'BillingCypressAttribute:checkout:views:CHECKOUT_SUCCESS_FIRST_INSTRUCTION_TITLE',
      ADDRESS_LINE_AUTOCOMPLETION_ITEM: 'div.pac-container.pac-logo div.pac-item',
      CREDIT_CARD_NUMBER_AUTO_COMPLETION_LIST: 'div.cb-pmcard__options',
      CREDIT_CARD_NUMBER_AUTO_COMPLETION_ITEM: 'div.cb-pmcard__options .cb-pmcard__option',
      PAYMENT_SUCCESS: 'BillingCypressAttribute:checkout:views:PAYMENT_SUCCESS',
      REDIRECT_PAYMENT_SUCCESS: 'BillingCypressAttribute:checkout:views:REDIRECT_PAYMENT_SUCCESS',
      TRUST_PILOT_WIDGET: 'BillingCypressAttribute:views:TRUST_PILOT_WIDGET',
      FEE_SCHEDULE_IFRAME: 'BillingCypressAttribute:checkout:links:FEE_SCHEDULE_IFRAME',
      BRAND_LOGO: 'BillingCypressAttribute:checkout:links:BRAND_LOGO'
    },
    texts: {
      CHECKOUT_CONSENT_TEXT: 'BillingCypressAttribute:checkout:inputs:CHECKOUT_CONSENT_TEXT',
      CHECKOUT_CONNECTED_ACCOUNT_CONSENT_TEXT:
        'BillingCypressAttribute:checkout:inputs:CHECKOUT_CONNECTED_ACCOUNT_CONSENT_TEXT',
      CHECKOUT_CONSENT_SUBPOINT_TEXT:
        'BillingCypressAttribute:checkout:inputs:CHECKOUT_CONSENT_SUBPOINT_TEXT'
    }
  },
  paymentMethod: {
    buttons: {
      EMAIL_VERIFICATION_CONTINUE: 'button[data-cb-id="portal_auth_action"]'
    },
    inputs: {
      EMAIL: 'input[type="email"]'
    },
    views: {}
  },
  uplift: {
    buttons: {
      START_A_REQUEST: 'BillingCypressAttribute:uplift:buttons:START_A_REQUEST'
    }
  },
  checkoutSession: {
    views: {
      VAULT_PLAN_FLOW: 'BillingCypressAttribute:checkoutSession:views:VAULT_PLAN_FLOW',
      STANDARD_PLAN_FLOW: 'BillingCypressAttribute:checkoutSession:views:STANDARD_PLAN_FLOW',
      STANDARD_PLAN_FLOW_HEADER:
        'BillingCypressAttribute:checkoutSession:views:STANDARD_PLAN_FLOW_HEADER',
      STANDARD_PLAN_FLOW_SUBHEADER:
        'BillingCypressAttribute:checkoutSession:views:STANDARD_PLAN_FLOW_SUBHEADER',
      VAULT_PLAN_PRICE: 'BillingCypressAttribute:checkoutSession:views:VAULT_PLAN_PRICE',
      ADDON_CARD_PRICE: 'BillingCypressAttribute:checkoutSession:views:ADDON_CARD_PRICE',
      VAULT_PLAN_PRICE_RECURRING:
        'BillingCypressAttribute:checkoutSession:views:STANDARD_PLAN_PRICE_RECURRING'
    },
    inputs: {
      CONSENT_CHECKBOX: 'BillingCypressAttribute:checkoutSession:inputs:CONSENT_CHECKBOX',
      ADVISOR_CONSENT_CHECKBOX:
        'BillingCypressAttribute:checkoutSession:inputs:ADVISOR_CONSENT_CHECKBOX'
    },
    buttons: {
      SHOW_OTHER_PLANS: 'BillingCypressAttribute:checkoutSession:buttons:SHOW_OTHER_PLANS'
    }
  },
  billingPlans: {
    views: {
      CARD_BOX: 'BillingCypressAttribute:billingPlans:views:CARD_BOX',
      MOST_POPULAR_TAG: 'BillingCypressAttribute:billingPlans:views:MOST_POPULAR_TAG',
      BLURRED_DIV: 'BillingCypressAttribute:billingPlans:views:BLURRED_DIV',
      PLAN_PARTY_DIV: 'BillingCypressAttribute:billingPlans:views:PLAN_PARTY_DIV',
      NO_JURISDICTION_OVERLAY: 'BillingCypressAttribute:billingPlans:views:NO_JURISDICTION_OVERLAY'
    }
  },
  advisor: {
    views: {
      TAG: 'BillingCypressAttribute:advisor:views:TAG',
      PERIOD_RANGE: 'BillingCypressAttribute:advisor:views:PERIOD_RANGE',
      DESCRIPTION: 'BillingCypressAttribute:advisor:views:DESCRIPTION',
      PRICE: 'BillingCypressAttribute:advisor:views:PRICE',
      NEXT_BILLING_AT: 'BillingCypressAttribute:advisor:views:NEXT_BILLING_AT',
      BRAND_LOGO: 'BillingCypressAttribute:advisor:views:BRAND_LOGO',
      PLAN_OVERVIEW_CARD: 'BillingCypressAttribute:advisor:views:PLAN_OVERVIEW_CARD',
      PAYMENT_METHOD: 'BillingCypressAttribute:advisor:views:PAYMENT_METHOD',
      UPCOMING_PLAN: 'BillingCypressAttribute:advisor:views:UPCOMING_PLAN',
      PAYMENT_METHOD_RESUBSCRIBE_BANNER:
        'BillingCypressAttribute:advisor:views:PAYMENT_METHOD_RESUBSCRIBE_BANNER'
    },
    buttons: {
      CANCEL_PLAN: 'BillingCypressAttribute:advisor:buttons:CANCEL_PLAN',
      MANAGE_PLAN: 'BillingCypressAttribute:advisor:buttons:MANAGE_PLAN',
      KEEP_MY_PLAN: 'BillingCypressAttribute:advisor:buttons:KEEP_MY_PLAN',
      CONTINUE: 'BillingCypressAttribute:advisor:buttons:CONTINUE'
    }
  }
};
